import { Flex, styled } from '@acko-tech/building-blocks.ui.common'
import { Text } from '@acko-tech/building-blocks.ui.typography'

export const Wrapper = styled(Flex)`
  background: #f5f5f5;
  align-items: center;
  justify-content: center;
  min-height: 91.5vh;
`

export const Container = styled(Flex)`
  border: 1px solid #e7e7f0;
  border-radius: 16px;
  width: 900px;
  background: #ffffff;
  height: max-content;
  padding: 32px;
  min-height: 568px;
`

export const Heading = styled(Text)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #040222;
  margin-bottom: 32px;
`

export const SelectButton = styled.span`
  padding: 8px 16px;
  background: ${props => (props.selected ? '#F2FFF8' : '#ffffff')};
  border: 1px solid ${props => (props.selected ? '#0FA457' : '#e7e7f0')};
  border-radius: 20px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #040222;
  max-width: max-content;
  margin-right: 15px;
  &:hover {
    cursor: pointer;
  }
`

export const ButtonsContainer = styled(Flex)`
  margin-bottom: 32px;
  flex-wrap: wrap;
`

export const NextButton = styled.button`
  border: none;
  background: #0fa457;
  border-radius: 8px;
  padding: 13px 16px;
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  width: max-content;
  align-self: flex-end;
  &:hover {
    cursor: pointer;
  }
  &:disabled {
    cursor: not-allowed;
    background: #e7e7f0;
  }
`
